import { lighten } from '@mui/system'

// Clickable things brighten a touch on hover: links lift more so the color
// shift reads; filled buttons only whisper so their label stays legible.
export const hoverAmount = {
  text: 0.16,
  fill: 0.06
}

export const hoverTransition = '0.15s ease'

export function brighten(color: string, amount: number) {
  if (color === 'transparent' || color === 'inherit') return color
  return lighten(color, amount)
}
